export default __webpack_public_path__ + "/assets/72d87e58241cde591383c8bf8734806d.jpg";